var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AdminReservationExtraListBuilder } from '../builders/adminReservationExtraList-builder';
import { AdminReservationExtraBuilder } from '../builders/adminReservationExtra-builder';
import { AdminReservationBuilder } from '../builders/adminReservation-builder';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class AdminReservationExtraApiService {
    constructor(authenticatedApi) {
        this.authenticatedApi = authenticatedApi;
    }
    list(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/adminreservationsExtras/list`, payload).toPromise();
            return AdminReservationExtraListBuilder.buildAdminReservationExtraList(response);
        });
    }
    markInProgress(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminreservationsExtras/mark_inprogress/${id}`).toPromise();
            return AdminReservationExtraBuilder.buildAdminReservationExtra(response);
        });
    }
    markCompleted(id, send_confirmation_to_client) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            if (send_confirmation_to_client) {
                const payload = { send_confirmation_to_client };
                response = yield this.authenticatedApi.post(`/adminreservationsExtras/mark_completed/${id}`, payload).toPromise();
            }
            else {
                response = yield this.authenticatedApi.post(`/adminreservationsExtras/mark_completed/${id}`).toPromise();
            }
            return AdminReservationExtraBuilder.buildAdminReservationExtra(response);
        });
    }
    markPending(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminreservationsExtras/mark_pending/${id}`).toPromise();
            return AdminReservationExtraBuilder.buildAdminReservationExtra(response);
        });
    }
    delete(id, params, send_confirmation_to_client) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            if (send_confirmation_to_client) {
                payload.send_confirmation_to_client = send_confirmation_to_client;
            }
            const response = yield this.authenticatedApi.post(`/adminreservationsExtras/delete/${id}`, payload).toPromise();
            return AdminReservationExtraBuilder.buildAdminReservationExtra(response);
        });
    }
    listKeyReservationsExtra(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/adminreservationsExtras/list_key_space_operations`, payload).toPromise();
            return response;
        });
    }
    keySpaceCalculate(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/adminreservationsExtras/key_space_calculate/${id}`).toPromise();
            return response;
        });
    }
    keySpaceStartInOperation(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminreservationsExtras/key_space_start_in_operation_timestamp/${id}`).toPromise();
            return response;
        });
    }
    keySpaceCompleteInOperation(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminreservationsExtras/key_space_complete_in_operation_timestamp/${id}`).toPromise();
            return response;
        });
    }
    keySpaceStartOutOperation(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminreservationsExtras/key_space_start_out_operation_timestamp/${id}`).toPromise();
            return response;
        });
    }
    keySpaceCompleteoUTOperation(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminreservationsExtras/key_space_complete_out_operation_timestamp/${id}`).toPromise();
            return response;
        });
    }
    keySpaceMove(id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.put(`/adminreservationsExtras/key_space_move/${id}`, payload).toPromise();
            return response;
        });
    }
    keySpaceRemove(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.put(`/adminreservationsExtras/key_space_remove/${id}`).toPromise();
            return response;
        });
    }
    nextAutomaticPlace(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi
                .post(`/adminreservationsExtras/next_automatic_place/${id}`)
                .toPromise();
            return response;
        });
    }
    separateExtraBill(id, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi
                .post(`/adminreservationsExtras/separate_bill/${id}`, JSON.stringify(payload))
                .toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
}
AdminReservationExtraApiService.ɵfac = function AdminReservationExtraApiService_Factory(t) { return new (t || AdminReservationExtraApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
AdminReservationExtraApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AdminReservationExtraApiService, factory: AdminReservationExtraApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AdminReservationExtraApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=admin-reservation-extra-api.service.js.map